import React from 'react';
import { Award, Users, Building2, TrendingUp } from 'lucide-react';
import { companyInfo } from '../mock';

const About = () => {
  return (
    <section id="about" className="py-24 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            About <span className="text-amber-700">{companyInfo.name}</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Leading the way in luxury real estate development with unmatched quality and innovation
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-12 items-center mb-16">
          {/* Image */}
          <div className="relative">
            <div className="absolute inset-0 bg-gradient-to-r from-amber-500 to-amber-600 rounded-2xl transform rotate-3"></div>
            <img
              src="https://i.postimg.cc/Prq6k3Ht/sai-adinath.jpg"
              alt="About Kiana Developers"
              className="relative rounded-2xl shadow-2xl w-full h-[500px] object-cover"
            />
          </div>

          {/* Content */}
          <div>
            <h3 className="text-3xl font-bold text-gray-900 mb-6">
              Crafting Excellence Since 2005
            </h3>
            <p className="text-gray-600 mb-6 leading-relaxed text-lg">
              {companyInfo.about}
            </p>
            <p className="text-gray-600 mb-8 leading-relaxed">
              Our team of expert architects, engineers, and designers work tirelessly to create spaces that inspire and endure. Every project is a testament to our commitment to excellence, sustainability, and customer satisfaction.
            </p>

            {/* Quick Stats */}
            <div className="grid grid-cols-2 gap-6">
              <div className="bg-white rounded-xl p-6 shadow-lg border border-gray-100 hover:shadow-xl transition-shadow">
                <div className="flex items-center space-x-4">
                  <div className="w-12 h-12 bg-gradient-to-br from-amber-100 to-amber-200 rounded-lg flex items-center justify-center">
                    <Building2 className="text-amber-700" size={24} />
                  </div>
                  <div>
                    <div className="text-2xl font-bold text-gray-900">{companyInfo.projects.split('+')[0]}+</div>
                    <div className="text-sm text-gray-600">Projects</div>
                  </div>
                </div>
              </div>
              <div className="bg-white rounded-xl p-6 shadow-lg border border-gray-100 hover:shadow-xl transition-shadow">
                <div className="flex items-center space-x-4">
                  <div className="w-12 h-12 bg-gradient-to-br from-amber-100 to-amber-200 rounded-lg flex items-center justify-center">
                    <Users className="text-amber-700" size={24} />
                  </div>
                  <div>
                    <div className="text-2xl font-bold text-gray-900">{companyInfo.customers.split('+')[0]}+</div>
                    <div className="text-sm text-gray-600">Families</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Values */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          <div className="bg-white rounded-xl p-8 shadow-lg border border-gray-100 hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2">
            <div className="w-16 h-16 bg-gradient-to-br from-amber-500 to-amber-600 rounded-2xl flex items-center justify-center mb-6">
              <Award className="text-white" size={32} />
            </div>
            <h4 className="text-xl font-bold text-gray-900 mb-3">Quality First</h4>
            <p className="text-gray-600 leading-relaxed">
              Uncompromising standards in construction, materials, and finishing to ensure lasting value.
            </p>
          </div>

          <div className="bg-white rounded-xl p-8 shadow-lg border border-gray-100 hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2">
            <div className="w-16 h-16 bg-gradient-to-br from-amber-500 to-amber-600 rounded-2xl flex items-center justify-center mb-6">
              <TrendingUp className="text-white" size={32} />
            </div>
            <h4 className="text-xl font-bold text-gray-900 mb-3">Innovation</h4>
            <p className="text-gray-600 leading-relaxed">
              Embracing cutting-edge technology and sustainable practices in every project.
            </p>
          </div>

          <div className="bg-white rounded-xl p-8 shadow-lg border border-gray-100 hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2">
            <div className="w-16 h-16 bg-gradient-to-br from-amber-500 to-amber-600 rounded-2xl flex items-center justify-center mb-6">
              <Users className="text-white" size={32} />
            </div>
            <h4 className="text-xl font-bold text-gray-900 mb-3">Customer Focus</h4>
            <p className="text-gray-600 leading-relaxed">
              Your dreams and satisfaction are at the heart of everything we do.
            </p>
          </div>

          <div className="bg-white rounded-xl p-8 shadow-lg border border-gray-100 hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2">
            <div className="w-16 h-16 bg-gradient-to-br from-amber-500 to-amber-600 rounded-2xl flex items-center justify-center mb-6">
              <Building2 className="text-white" size={32} />
            </div>
            <h4 className="text-xl font-bold text-gray-900 mb-3">Timely Delivery</h4>
            <p className="text-gray-600 leading-relaxed">
              Committed to delivering projects on schedule without compromising quality.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
